import { MealTagItem } from "./MealTagItem";

export function MealTagsList({ mealTags, onDelete }) {
  return (
    <div className="flex flex-wrap gap-2">
      {mealTags.map((tag) => (
        <MealTagItem key={tag.tagId} tag={tag} onDelete={onDelete} />
      ))}
    </div>
  );
}
